import {
  createFulfillmentMethod as publicCreateFulfillmentMethod,
  bulkCreateFulfillmentMethods as publicBulkCreateFulfillmentMethods,
  getFulfillmentMethod as publicGetFulfillmentMethod,
  updateFulfillmentMethod as publicUpdateFulfillmentMethod,
  deleteFulfillmentMethod as publicDeleteFulfillmentMethod,
  queryFulfillmentMethods as publicQueryFulfillmentMethods,
  typedQueryFulfillmentMethods as publicTypedQueryFulfillmentMethods,
  listFulfillmentMethods as publicListFulfillmentMethods,
  listAvailableFulfillmentMethodsForAddress as publicListAvailableFulfillmentMethodsForAddress,
  getAccumulatedFulfillmentMethodsAvailability as publicGetAccumulatedFulfillmentMethodsAvailability,
  getCombinedMethodAvailability as publicGetCombinedMethodAvailability,
  getAggregatedMethodAvailability as publicGetAggregatedMethodAvailability,
  bulkUpdateFulfillmentMethodTags as publicBulkUpdateFulfillmentMethodTags,
  bulkUpdateFulfillmentMethodTagsByFilter as publicBulkUpdateFulfillmentMethodTagsByFilter,
} from './restaurants-v1-fulfillment-method-fulfillment-methods.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  FulfillmentMethodQuery,
  FulfillmentMethodsQueryBuilder,
  QueryFulfillmentMethodsOptions,
  typedQueryFulfillmentMethods as universalTypedQueryFulfillmentMethods,
} from './restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';
import { onFulfillmentMethodCreated as publicOnFulfillmentMethodCreated } from './restaurants-v1-fulfillment-method-fulfillment-methods.public.js';
import { onFulfillmentMethodDeleted as publicOnFulfillmentMethodDeleted } from './restaurants-v1-fulfillment-method-fulfillment-methods.public.js';
import { onFulfillmentMethodUpdated as publicOnFulfillmentMethodUpdated } from './restaurants-v1-fulfillment-method-fulfillment-methods.public.js';

function customQueryFulfillmentMethods(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryFulfillmentMethodsOptions) =>
      publicQueryFulfillmentMethods(httpClient)(options),
    typedQueryFunction: (
      query: FulfillmentMethodQuery,
      options?: QueryFulfillmentMethodsOptions
    ) => publicTypedQueryFulfillmentMethods(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: FulfillmentMethodQuery,
    options?: QueryFulfillmentMethodsOptions
  ): ReturnType<typeof universalTypedQueryFulfillmentMethods>;
  function overloadedQuery(
    options?: QueryFulfillmentMethodsOptions
  ): FulfillmentMethodsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: FulfillmentMethodQuery | QueryFulfillmentMethodsOptions,
    options?: QueryFulfillmentMethodsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createFulfillmentMethod: MaybeContext<
  BuildRESTFunction<typeof publicCreateFulfillmentMethod> &
    typeof publicCreateFulfillmentMethod
> = /*#__PURE__*/ createRESTModule(publicCreateFulfillmentMethod);
export const bulkCreateFulfillmentMethods: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateFulfillmentMethods> &
    typeof publicBulkCreateFulfillmentMethods
> = /*#__PURE__*/ createRESTModule(publicBulkCreateFulfillmentMethods);
export const getFulfillmentMethod: MaybeContext<
  BuildRESTFunction<typeof publicGetFulfillmentMethod> &
    typeof publicGetFulfillmentMethod
> = /*#__PURE__*/ createRESTModule(publicGetFulfillmentMethod);
export const updateFulfillmentMethod: MaybeContext<
  BuildRESTFunction<typeof publicUpdateFulfillmentMethod> &
    typeof publicUpdateFulfillmentMethod
> = /*#__PURE__*/ createRESTModule(publicUpdateFulfillmentMethod);
export const deleteFulfillmentMethod: MaybeContext<
  BuildRESTFunction<typeof publicDeleteFulfillmentMethod> &
    typeof publicDeleteFulfillmentMethod
> = /*#__PURE__*/ createRESTModule(publicDeleteFulfillmentMethod);
export const listFulfillmentMethods: MaybeContext<
  BuildRESTFunction<typeof publicListFulfillmentMethods> &
    typeof publicListFulfillmentMethods
> = /*#__PURE__*/ createRESTModule(publicListFulfillmentMethods);
export const listAvailableFulfillmentMethodsForAddress: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableFulfillmentMethodsForAddress> &
    typeof publicListAvailableFulfillmentMethodsForAddress
> = /*#__PURE__*/ createRESTModule(
  publicListAvailableFulfillmentMethodsForAddress
);
export const getAccumulatedFulfillmentMethodsAvailability: MaybeContext<
  BuildRESTFunction<typeof publicGetAccumulatedFulfillmentMethodsAvailability> &
    typeof publicGetAccumulatedFulfillmentMethodsAvailability
> = /*#__PURE__*/ createRESTModule(
  publicGetAccumulatedFulfillmentMethodsAvailability
);
export const getCombinedMethodAvailability: MaybeContext<
  BuildRESTFunction<typeof publicGetCombinedMethodAvailability> &
    typeof publicGetCombinedMethodAvailability
> = /*#__PURE__*/ createRESTModule(publicGetCombinedMethodAvailability);
export const getAggregatedMethodAvailability: MaybeContext<
  BuildRESTFunction<typeof publicGetAggregatedMethodAvailability> &
    typeof publicGetAggregatedMethodAvailability
> = /*#__PURE__*/ createRESTModule(publicGetAggregatedMethodAvailability);
export const bulkUpdateFulfillmentMethodTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateFulfillmentMethodTags> &
    typeof publicBulkUpdateFulfillmentMethodTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateFulfillmentMethodTags);
export const bulkUpdateFulfillmentMethodTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateFulfillmentMethodTagsByFilter> &
    typeof publicBulkUpdateFulfillmentMethodTagsByFilter
> = /*#__PURE__*/ createRESTModule(
  publicBulkUpdateFulfillmentMethodTagsByFilter
);
export const queryFulfillmentMethods: MaybeContext<
  BuildRESTFunction<typeof customQueryFulfillmentMethods> &
    typeof customQueryFulfillmentMethods
> = /*#__PURE__*/ createRESTModule(customQueryFulfillmentMethods);
/** */
export const onFulfillmentMethodCreated: BuildEventDefinition<
  typeof publicOnFulfillmentMethodCreated
> &
  typeof publicOnFulfillmentMethodCreated = createEventModule(
  publicOnFulfillmentMethodCreated
);
/**
 * Triggered when a fulfillment method is deleted.
 */
export const onFulfillmentMethodDeleted: BuildEventDefinition<
  typeof publicOnFulfillmentMethodDeleted
> &
  typeof publicOnFulfillmentMethodDeleted = createEventModule(
  publicOnFulfillmentMethodDeleted
);
/**
 * Triggered when a fulfillment method is updated.
 */
export const onFulfillmentMethodUpdated: BuildEventDefinition<
  typeof publicOnFulfillmentMethodUpdated
> &
  typeof publicOnFulfillmentMethodUpdated = createEventModule(
  publicOnFulfillmentMethodUpdated
);

export {
  FulfillmentMethodType,
  SubdivisionType,
  Type,
  Unit,
  EntitiesDayOfWeek,
  WebhookIdentityType,
  AdditionalInfoLabel,
  SortOrder,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
} from './restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';
export {
  FulfillmentMethod,
  FulfillmentMethodMethodOptionsOneOf,
  PickupInfo,
  CommonAddress,
  CommonAddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  DeliveryInfo,
  DeliveryArea,
  DeliveryAreaAreaOptionsOneOf,
  Radius,
  PostalCode,
  CustomArea,
  Availability,
  DayOfWeekAvailability,
  TimeOfDayRange,
  TimeOfDay,
  ExtendedFields,
  Tags,
  TagList,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  DineInInfo,
  DineInInfoAdditionalInfoLabelOptionsOneOf,
  CustomConfig,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateFulfillmentMethodRequest,
  CreateFulfillmentMethodResponse,
  BulkCreateFulfillmentMethodsRequest,
  BulkCreateFulfillmentMethodsResponse,
  BulkCreateFulfillmentMethodResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  GetFulfillmentMethodRequest,
  GetFulfillmentMethodResponse,
  UpdateFulfillmentMethodRequest,
  UpdateFulfillmentMethodResponse,
  DeleteFulfillmentMethodRequest,
  DeleteFulfillmentMethodResponse,
  QueryFulfillmentMethodsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryFulfillmentMethodsResponse,
  CursorPagingMetadata,
  Cursors,
  ListFulfillmentMethodsRequest,
  ListFulfillmentMethodsResponse,
  ListAvailableFulfillmentMethodsForAddressRequest,
  ListAvailableFulfillmentMethodsForAddressResponse,
  ListActiveFulfillmentMethodsRequest,
  ListActiveFulfillmentMethodsResponse,
  GetAccumulatedFulfillmentMethodsAvailabilityRequest,
  GetAccumulatedFulfillmentMethodsAvailabilityResponse,
  GetCombinedMethodAvailabilityRequest,
  GetCombinedMethodAvailabilityResponse,
  GetAggregatedMethodAvailabilityRequest,
  GetAggregatedMethodAvailabilityResponse,
  BulkUpdateFulfillmentMethodTagsRequest,
  BulkUpdateFulfillmentMethodTagsResponse,
  CommonItemMetadata,
  BulkUpdateFulfillmentMethodTagsResult,
  CommonBulkActionMetadata,
  BulkUpdateFulfillmentMethodTagsByFilterRequest,
  BulkUpdateFulfillmentMethodTagsByFilterResponse,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  SiteCreated,
  SiteCloned,
  Empty,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  FulfillmentMethodCreatedEnvelope,
  FulfillmentMethodDeletedEnvelope,
  FulfillmentMethodUpdatedEnvelope,
  BulkCreateFulfillmentMethodsOptions,
  UpdateFulfillmentMethod,
  QueryFulfillmentMethodsOptions,
  FulfillmentMethodsQueryResult,
  FulfillmentMethodsQueryBuilder,
  FulfillmentMethodQuerySpec,
  ListFulfillmentMethodsOptions,
  ListAvailableFulfillmentMethodsForAddressOptions,
  GetAccumulatedFulfillmentMethodsAvailabilityOptions,
  BulkUpdateFulfillmentMethodTagsOptions,
  BulkUpdateFulfillmentMethodTagsByFilterOptions,
} from './restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';
export { utils } from './restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';
export {
  FulfillmentMethodTypeWithLiterals,
  SubdivisionTypeWithLiterals,
  TypeWithLiterals,
  UnitWithLiterals,
  EntitiesDayOfWeekWithLiterals,
  WebhookIdentityTypeWithLiterals,
  AdditionalInfoLabelWithLiterals,
  SortOrderWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  BulkUpdateFulfillmentMethodTagsApplicationErrors,
  BulkUpdateFulfillmentMethodTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  FulfillmentMethodQuery,
} from './restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';
